import { render } from "./TimeSheetPeriod.vue?vue&type=template&id=4f3a2571"
import script from "./TimeSheetPeriod.vue?vue&type=script&lang=js"
export * from "./TimeSheetPeriod.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Azize HRM\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__